import { GraphQLClient, gql } from 'graphql-request';

const config = {
    graphQlUrl: location.hostname !== 'localhost' ? `https://editello.com/graphql` : 'http://localhost:8082/graphql',
}

export default {
    getOneByHash,
    createProject,
    updateProject,
    duplicateProject,
    updateItem,
    setStatus,
    setOrderId,
};

async function getOneByHash(id) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      {
        project(hash: "${id}") {
            id,
            email,
            user_name,
            hash,
            order_id,
            source,
            created_at,
            scenes: items {
                id,
                name,
                note,
                guests {
                    content,
                    display,
                    x,
                    y
                },
                attributes {
                    guestList,
                    exportAll,
                    tabs
                }
                versions {
                    id,
                    name,
                    content,
                    margin,
                    cuttingLine,
                    border,
                    borderColor,
                    width,
                    height,
                    attributes {
                        personalizedField,
                        blockFonts
                    }
                }
            },
            statuses {
                id,
                name,
                code
            },
            status {
                id,
                name,
                code
            }
        }
      }
    `

    const data = await graphQLClient.request(query)

    return data.project
}

async function createProject(project, saveData) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      mutation create ($code: String, $email: String, $userName: String, $orderId: String, $items: String) {
        createByDraft(code: $code, email: $email, user_name: $userName, order_id: $orderId, items: $items) {
            success,
            project {
                id,
                hash,
                email,
                user_name,
                order_id,
                source,
                created_at,
                scenes: items {
                    id,
                    name,
                    note,
                    guests {
                        content,
                        display,
                        x,
                        y
                    },
                    attributes {
                        guestList,
                        exportAll,
                    tabs
                    },
                    versions {
                        id,
                        name,
                        content,
                        margin,
                        cuttingLine,
                        border,
                        borderColor,
                        width,
                        height,
                        attributes {
                            personalizedField,
                        blockFonts
                        }
                    }
                },
                statuses {
                    id,
                    name,
                    code
                },
                status {
                    id,
                    name,
                    code
                }
            }
        }
      }
    `

    const items = project.scenes.map((item) => {
        return {
            id: item.id,
            name: item.name,
            note: item.note,
            guests: item.guests,
            versions: item.versions.map((version) => {
                return {
                    id: version.id,
                    content: version.content
                }
            })
        }
    })

    const data = await graphQLClient.request(query, {
        code: project.code,
        email: saveData.email,
        userName: saveData.user_name,
        orderId: saveData.orderId ?? '',
        items: JSON.stringify(items)
    })

    console.log('----------------', data)

    if (!data.createByDraft.success) {
        throw new Error('Cannot create project')
    }

    console.log('data', data)

    return data.createByDraft.project
}

async function duplicateProject(project, orderId) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      mutation duplicateByDraftCode ($code: String, $email: String, $userName: String, $orderId: String) {
        duplicateByDraftCode(code: $code, email: $email, user_name: $userName, order_id: $orderId) {
            success,
            project {
                id,
                hash,
                email,
                user_name,
                order_id,
                source,
                created_at,
            }
        }
      }
    `

    const data = await graphQLClient.request(query, {
        code: project.code,
        email: project.email,
        userName: project.name,
        orderId
    })

    if (!data.duplicateByDraftCode.success) {
        throw new Error('Cannot create project')
    }

    return data.duplicateByDraftCode.project
}

async function updateProject(project) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      mutation updateProject($id: Int!, $items: String!) {
        updateProject(id: $id, items: $items) {
            success,
            project {
                id,
                hash,
                email,
                user_name,
                order_id,
                source,
                created_at,
                scenes: items {
                    id,
                    name,
                    note,
                    guests {
                        content,
                        display,
                        x,
                        y
                    },
                    attributes {
                        guestList,
                        exportAll,
                    tabs
                    },
                    versions {
                        id,
                        name,
                        content,
                        margin,
                        cuttingLine,
                        border,
                        borderColor,
                        width,
                        height,
                        attributes {
                            personalizedField,
                        blockFonts
                        }
                    }
                },
                statuses {
                    id,
                    name,
                    code
                },
                status {
                    id,
                    name,
                    code
                }
            }
        }
      }
    `

    const data = await graphQLClient.request(query, {
        id: project.id,
        items: JSON.stringify(project.scenes)
    })

    if (!data.updateProject.success) {
        throw new Error('Cannot update project')
    }

    return data.updateProject.project
}

async function setStatus(project, status) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      mutation setProjectStatus($id: Int!, $status: String!) {
        setProjectStatus(id: $id, status: $status) {
            success,
            project {
                id,
                hash,
                email,
                user_name,
                order_id,
                source,
                created_at,
                scenes: items {
                    id,
                    name,
                    note,
                    guests {
                        content,
                        display,
                        x,
                        y
                    },
                    attributes {
                        guestList,
                        exportAll,
                    tabs
                    },
                    versions {
                        id,
                        name,
                        content,
                        margin,
                        cuttingLine,
                        border,
                        borderColor,
                        width,
                        height,
                        attributes {
                            personalizedField,
                        blockFonts
                        }
                    }
                },
                statuses {
                    id,
                    name,
                    code
                },
                status {
                    id,
                    name,
                    code
                }
            }
        }
      }
    `

    const data = await graphQLClient.request(query, {
        id: project.id,
        status: status
    })

    if (!data.setProjectStatus.success) {
        throw new Error('Cannot set status of project')
    }

    return data.setProjectStatus.project
}

async function setOrderId(hash, orderId) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      mutation setProjectOrderId($hash: String!, $orderId: String!) {
        setProjectOrderId(hash: $hash, orderId: $orderId) {
            success
        }
      }
    `

    const data = await graphQLClient.request(query, {
        hash,
        orderId,
    })

    return data.setProjectOrderId.success
}

async function updateItem(itemId, data) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })
    console.log('itemId', itemId, data)

    const query = gql`
      mutation {
        updateItem(id: ${itemId}, name: "${data.name}", note: "${data.note}") {
            success,
            error
        }
      }
    `

    const result = await graphQLClient.request(query, {
    })
    
    console.log('result', result)
    
    if (!result.updateItem.success) {
        throw new Error('Cannot update project version')
    }


    return result.updateItem.success
}